import _ from 'lodash';
import { Reducer } from 'redux';
import {
  SalesMessagePagesAction,
  GET_MAINPERMIT_CONTENTS,
  GET_SINGLE_VEHICLE_ENTRY,
  GET_MULTIPLE_VEHICLE_ENTRY,
  GET_PERMIT_PAYMENT,
  GET_PERMIT_PAYMENT_PAYROLL,
  GET_PAYROLL_AGREEMENT,
  GET_SCHOOL_ACCOUNT_EXTRA_TEXT,
  GET_SCHOOL_ACCOUNT_AGREEMENT_TEXT,
  GET_REVIEW_ORDER,
  GET_CHECKBOX_AGREEMENT,
  GET_ORDER_COMPLETE,
  REFRESH_SALES_MESSAGE_PAGES_STORE,
  GET_NEW_PERMIT_ORDER_COMPLETE,
} from './actions';
import { LogoutAction, LOGOUT, ResetAdminStateAction, RESET_ADMIN_STATE } from 'store/user/actions';

export interface MainPermitState {
  readonly id: number;
  readonly defaultFlag: boolean;
  readonly name: string;
  readonly page: string;
  readonly text: string;
  readonly mainPermit?: SalesMessagePages;
  readonly singleVehicle?: SalesMessagePages;
  readonly multipleVehicle?: SalesMessagePages;
  readonly permitPyment?: SalesMessagePages;
  readonly permitPaymentPayroll?: SalesMessagePages;
  readonly payrollAgreement?: SalesMessagePages;
  readonly schoolAccountExtraText?: SalesMessagePages;
  readonly schoolAccountAgreementText?: SalesMessagePages;
  readonly reviewOrder?: SalesMessagePages;
  readonly checkboxAgreement?: SalesMessagePages;
  readonly orderComplete?: SalesMessagePages;
  readonly newPermitOrderComplete?: SalesMessagePages;
}

export const defaultState: MainPermitState = {
  id: 0,
  defaultFlag: false,
  name: '',
  page: '',
  text: '',
  mainPermit: undefined,
  singleVehicle: undefined,
  multipleVehicle: undefined,
  permitPyment: undefined,
  permitPaymentPayroll: undefined,
  payrollAgreement: undefined,
  schoolAccountExtraText: undefined,
  schoolAccountAgreementText: undefined,
  reviewOrder: undefined,
  checkboxAgreement: undefined,
  orderComplete: undefined,
  newPermitOrderComplete: undefined,
};

export const reducer: Reducer<MainPermitState, SalesMessagePagesAction | LogoutAction | ResetAdminStateAction> = (
  state = defaultState,
  action,
) => {
  //console.log('driver::::' + action.payload);
  switch (action.type) {
    case GET_MAINPERMIT_CONTENTS:
      return {
        ...state,
        mainPermit: { ...action.payload[0] },
      };
    case GET_SINGLE_VEHICLE_ENTRY:
      return {
        ...state,
        singleVehicle: { ...action.payload[0] },
        // ...action.payload[0],
      };
    case GET_MULTIPLE_VEHICLE_ENTRY:
      return {
        ...state,
        multipleVehicle: { ...action.payload[0] },
      };
    case GET_PERMIT_PAYMENT:
      return {
        ...state,
        permitPyment: { ...action.payload[0] },
      };
    case GET_PERMIT_PAYMENT_PAYROLL:
      return {
        // ...action.payload[0],
        ...state,
        permitPaymentPayroll: { ...action.payload[0] },
      };
    case GET_PAYROLL_AGREEMENT:
      return {
        ...state,
        payrollAgreement: { ...action.payload[0] },
      };
    case GET_SCHOOL_ACCOUNT_EXTRA_TEXT:
      return {
        ...state,
        schoolAccountExtraText: { ...action.payload[0] },
      };
    case GET_SCHOOL_ACCOUNT_AGREEMENT_TEXT:
      return {
        ...state,
        schoolAccountAgreementText: { ...action.payload[0] },
      };
    case GET_REVIEW_ORDER:
      return {
        ...state,
        reviewOrder: { ...action.payload[0] },
      };
    case GET_CHECKBOX_AGREEMENT:
      return {
        ...state,
        checkboxAgreement: { ...action.payload[0] },
      };
    case GET_ORDER_COMPLETE:
      return {
        ...state,
        orderComplete: { ...action.payload[0] },
      };
    case GET_NEW_PERMIT_ORDER_COMPLETE:
      return {
        ...state,
        newPermitOrderComplete: { ...action.payload[0] },
      };
    case REFRESH_SALES_MESSAGE_PAGES_STORE:
      return defaultState;
    case LOGOUT:
      return defaultState;
    case RESET_ADMIN_STATE:
      return defaultState;
    default:
      return state;
  }
};

export default reducer;
